"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReEnteredPasswordError = exports.getPasswordError = exports.isValidPassword = exports.TRANSLATION_KEYS = void 0;
var MIN_PASSWORD_LENGTH = 6;
exports.TRANSLATION_KEYS = {
    TOO_SHORT: 'ErrorTooShort',
    INVALID: 'ErrorPasswordConsistMix',
    DO_NOT_MATCH: 'PasswordsDoNotMatch'
};
var isValidPassword = function (password) {
    var matchCount = 0;
    matchCount += password.match(/(?=.*\d)/) ? 1 : 0; // Digits
    matchCount += password.match(/(?=.*[a-z])/) ? 1 : 0; // lowercase
    matchCount += password.match(/(?=.*[A-Z])/) ? 1 : 0; // Uppercase
    matchCount += password.match(/\W/) ? 1 : 0; // Non-word (special) characters
    return matchCount >= 3;
};
exports.isValidPassword = isValidPassword;
var getPasswordError = function (password) {
    if (password.length < MIN_PASSWORD_LENGTH) {
        return exports.TRANSLATION_KEYS.TOO_SHORT;
    }
    if (!(0, exports.isValidPassword)(password)) {
        return exports.TRANSLATION_KEYS.INVALID;
    }
    return '';
};
exports.getPasswordError = getPasswordError;
var getReEnteredPasswordError = function (password, reEnteredPassword) {
    if (reEnteredPassword && password !== reEnteredPassword) {
        return exports.TRANSLATION_KEYS.DO_NOT_MATCH;
    }
    return '';
};
exports.getReEnteredPasswordError = getReEnteredPasswordError;
